import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserModel, UserService, CourseService, AuthService } from "@bt/core";
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from "angular-notifier";
import * as $ from 'jquery';
import { Router } from "@angular/router";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"]
})
export class ProfileComponent extends BaseComponent  implements OnInit, OnDestroy {
  public userFullName;
  public user: any;
  public currentModel: UserModel;
  public editModel: UserModel;
  public isEditEnable: boolean;
  private readonly notifier: NotifierService;
  public userRole: number;
	private pointsStr: string;
  private newPassword: string;
  public maxLength : number;
  public plans: any = [];
  public levels: any = [];
  public levelDicts: any = [];

  constructor(
    private userService: UserService, 
    notifierService: NotifierService,
    private router: Router,
    private authService: AuthService,
    private courseService: CourseService
  ) {
    super();
    this.currentModel = new UserModel();
    this.editModel = new UserModel();
    this.isEditEnable = false;
    this.notifier = notifierService;
    this.userRole = userService.getRole();
    this.pointsStr = "0";
    this.maxLength = 20;
    this.levels.forEach(element => {
      this.letterPattern[element.name] = element.label;
    });

  }

  public ngOnInit() {
    this.setLoading(true);
    this.loadUser();

    if(this.userRole == 2){
     $('#company-description').addClass('hidden');
    }else $('#company-description').removeClass('hidden');

  }

  public ngOnDestroy() {
    this.userService.reset();
  }

  public goToScormModule(plan:any){
          if(plan.orderNum==-1){
            if(!plan.isSuccessPassed){
              this.router.navigateByUrl('test/' + plan.id);
            }
            else{
              this.notifier.notify("error","Тест уже пройден")
            }
            
           return
          }
          this.router.navigateByUrl('scorm-module/' + plan.id);

    
  }



  public enableEdition() {
    this.isEditEnable = true;
  }
 
  public cancelEdition() {
    this.editModel = Object.assign({}, this.currentModel);
  }

  public loadUser(){
    var t = this;
    this.courseService.getUser()
      .then((resp) => {
        console.log(resp.data)
        this.editModel = resp.data;
        this.currentModel = Object.assign({}, resp.data);
        this.userService.currentUser = Object.assign({}, resp.data);
        t.setLoading(false);
      })
      .catch((error) => {
        console.error(error.error);
        t.setLoading(false);
        this.notifier.notify('error', 'Пожалуйста выполните авторизацию');
				this.authService.logout();
      });
  }

  public editPassword() {
    var t = this;

    t.userService.editPassword({newPassword: t.newPassword})
      .then((resp) => {
        this.notifier.notify('success', "Пароль успешно изменен");
        t.newPassword = null;
        this.setLoading(false);
      })
      .catch((error) => {
        console.error(error.error);
        t.setLoading(false);
      });
  }

  public isPasswordValid() : boolean {
    if(this.newPassword.length <= 5 && this.newPassword.length != 0) {
      this.notifier.notify('error', "Длина пароля должна превышать 5 символов");
      return false; 
    }
    return true; 
  }

  public saveChanges() {
    this.setLoading(true);
    
    if(this.newPassword != null) {
      if(this.isPasswordValid()) {
        this.editPassword();
      }
      else {
        this.setLoading(false);
        return;
      }
    }
    
    this.userService.editUserInfo(this.editModel)
    .then((resp) => {
      this.loadUser();
     // this.currentModel = Object.assign({}, resp.data);
     // this.userService.currentUser = Object.assign({}, resp.data);
      this.isEditEnable = false;
      this.notifier.notify('success', "Данные сохранены");
      this.setLoading(false);
    })
    .catch((error) => {
      console.error(error.error);
    });
  }

  public getRole(){
    return this.userService.getRole();
  }

  public currentUser(){
		return this.userService.currentUser;
  }
  public CheckPlans():boolean{
    let hasPlan = true;
    for(let level of this.levels) {
      if(this.plans[level.value].length!=0){
        hasPlan = true;
        break;
      } 
      else{
        hasPlan = false;
      } 
   }
   return hasPlan;
  }
}


// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts